import React from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";
import TextField from "components/form/textField/TextField";
import { useFormBuilderEditorContext } from "../../../formBuilderEditorContext";
import { useFormBuilderDebouncedUpdate } from "../../../hooks/debouncedUpdate/useFormBuilderDebouncedUpdate";
import { IFormBuilderText, TFormBuilderTextSettings } from "../../../model/item/formBuilderText";

interface IFormBuilderTextSettingsProps {
  item: IFormBuilderText;
}

export function FormBuilderTextSettings(props: IFormBuilderTextSettingsProps) {
  const { item } = props;

  const { t } = useTranslation();

  const { formBuilderController } = useFormBuilderEditorContext();

  const settings = item.data.settings;

  const debouncedContent = useFormBuilderDebouncedUpdate<string>({
    defaultValue: "",
    value: settings.content,
  });

  function dispatchSettings(partialNextSettings: Partial<TFormBuilderTextSettings>) {
    formBuilderController.updateItemSettings({
      key: item.key,
      prevItemSettings: {
        type: item.data.type,
        settings: cloneDeep(settings),
      },
      nextItemSettings: {
        type: item.data.type,
        settings: {
          ...cloneDeep(settings),
          ...partialNextSettings,
        },
      },
    });
  }

  return (
    <TextField
      label={t("Content")}
      noResize
      rows={4}
      value={debouncedContent.state.active ? debouncedContent.state.value : settings.content}
      onFocus={debouncedContent.activate}
      onChange={e =>
        debouncedContent.change(e.target.value, content => {
          dispatchSettings({ content });
        })
      }
      onBlur={() =>
        debouncedContent.commit(content => {
          dispatchSettings({ content });
        })
      }
    />
  );
}
